module.exports = __webpack_public_path__ + "static/media/join_2_over.520717b0.png";